/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, DAKSH_SCREEN, COMMON } from '../../global/Constants';
import { DakshSaleType, DakshStatus } from '../../global/Enum';
import DesktopFooter from '../common/DesktopFooter';
import Header from '../common/Header';
import Footer from '../common/Footer';
import './daksh.css';
import DakshHeader from './components/DakshHeader';
import Utilities from '../../global/Utilities';
import ViewQuantity from './components/ViewQuantity';
import TitleStatus from './components/TitleStatus';

class SubmitSale extends Component {

    constructor(props) {
        super(props);
        this.state = {
            saleType: DakshSaleType.SEEDWORKS_SALE,
        }
    }

    componentDidMount() {
        if (Utilities.checkLogin()) {
            const data = this.props.location.state;
            if (data) {
                Utilities.LogPrint("Krunal", data);
                this.setState({
                    //saleType: data.saleType
                });
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }

    }



    clickHandler = (type) => {
    }

    handleSubmitButton = () => {
        alert("Submit Button Clicked");
    }

    handleCancelButton = () => {
        this.props.history.goBack();
    }


    render() {
        //const { saleType } = this.state;
        return (
            <div>
                <Header />
                <Footer />

                <div className="container pt-35 daksh">
                    <DakshHeader />

                    <div className="row">
                        <div className="col-12 sale-table">
                            <TitleStatus
                                title={DAKSH_SCREEN.SALE}
                                status={DakshStatus.PENDING}
                            />

                            {/* Sale Table */}

                            <ViewQuantity
                                clickHandler={this.clickHandler} />
                        </div>

                        <div className="col-12 mt-4 mb-4 btn-group-w">
                            <button className="btn btn-primary w-182" onClick={this.handleSubmitButton}>{COMMON.SUBMIT}</button>
                            <button className="btn btn-secondary ml-3 w-182" onClick={this.handleCancelButton}>{COMMON.CANCEL}</button>
                        </div>

                    </div>
                </div>
                <DesktopFooter />
            </div>

        )
    }
}

export default withRouter(SubmitSale);